import React from 'react';
import { RobberyTheft as RobberyTheftIcon, RobberyTheftFull as RobberyTheftFullIcon } from '@magalu/stereo-ui-icons';
import { shape, string, arrayOf, number, oneOfType, func, bool } from 'prop-types';
import { label } from './robbery-theft.data';
import Options from './options';
import { Container, LabelComponent, ServiceOptionsContainer } from './robbery-theft.styles';
import { TitleContent, Description } from '../financial-services.styles';

const RobberyTheft = ({
  service,
  onChange,
  desktopMode,
  installmentQuantity
}) => {
  if (!(service != null && service.offers.length)) return null;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TitleContent, null, desktopMode ? /*#__PURE__*/React.createElement(RobberyTheftFullIcon, {
    width: 208,
    height: 59
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RobberyTheftIcon, {
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement(Description, {
    as: "p",
    mt: '10px'
  }, service == null ? void 0 : service.description))), /*#__PURE__*/React.createElement(LabelComponent, null, label)), /*#__PURE__*/React.createElement(ServiceOptionsContainer, null, /*#__PURE__*/React.createElement(Options, {
    options: service == null ? void 0 : service.offers,
    onChange: onChange,
    desktopMode: desktopMode,
    installmentQuantity: installmentQuantity
  })));
};

process.env.NODE_ENV !== "production" ? RobberyTheft.propTypes = {
  service: shape({
    description: string,
    offers: arrayOf(shape({
      id: oneOfType([string, number]),
      description: string
    }))
  }),
  onChange: func,
  desktopMode: bool,
  installmentQuantity: oneOfType([string, number])
} : void 0;
RobberyTheft.defaultProps = {
  service: {
    offers: []
  },
  desktopMode: false,
  installmentQuantity: null
};
export default RobberyTheft;